var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { previewProductNumberAssignment } from "../api/productNumberService";
import { resolveSelectionMaxMagnitude } from "../utils/newPrefixMagnitude";
/**
 * Highest allowed block size of a new publisher prefix for the agency prefix the user selected on the assign
 * page (FSD PP20). The backend computes it per selection, so it is asked with a decision-only preview for exactly
 * that agency prefix: it never reserves a number or creates a prefix. A value of a previous selection is never
 * reused: until the fresh answer arrives the safe default applies. A refetch for the same selection (e.g. after the
 * page's own reservation changed) keeps the previous answer meanwhile, so the page never falls back to its
 * heuristics while the decision for the current agency prefix is merely being refreshed. The same answer tells whether a new prefix is
 * needed at all and which existing prefixes still have a free number ({@code selectionPreview}), also when the
 * publisher's prefixes there are all used up (Tools #76358).
 */
export var useSelectedAgencyPrefixMaxMagnitude = function (_a) {
    var productId = _a.productId, publisherId = _a.publisherId, agencyPrefixId = _a.agencyPrefixId, reservedProductNumberId = _a.reservedProductNumberId, enabled = _a.enabled, isPublisherRoleOnly = _a.isPublisherRoleOnly;
    var ky = useOkapiKy();
    var _b = useQuery([
        "newPrefixMaxMagnitude",
        productId,
        publisherId,
        agencyPrefixId,
        reservedProductNumberId,
    ], function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        publisherId: publisherId,
                        agencyPrefixId: agencyPrefixId
                    };
                    return [4 /*yield*/, previewProductNumberAssignment(ky, {
                            productId: productId,
                            publisherId: publisherId,
                            agencyPrefixId: agencyPrefixId,
                            magnitude: 0,
                            decisionOnly: true,
                            productNumberId: reservedProductNumberId,
                        })];
                case 1: return [2 /*return*/, (_a.decision = _b.sent(),
                        _a)];
            }
        });
    }); }, {
        enabled: enabled && !!productId && !!publisherId && !!agencyPrefixId,
        cacheTime: 0,
        retry: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    }), data = _b.data, isError = _b.isError;
    var selectionPreview = enabled &&
        (data === null || data === void 0 ? void 0 : data.agencyPrefixId) === agencyPrefixId &&
        (data === null || data === void 0 ? void 0 : data.publisherId) === publisherId
        ? data.decision
        : undefined;
    return {
        maxMagnitude: resolveSelectionMaxMagnitude({
            selectionPreview: selectionPreview,
            isPublisherRoleOnly: isPublisherRoleOnly,
        }),
        allowedMagnitudes: (selectionPreview === null || selectionPreview === void 0 ? void 0 : selectionPreview.createNewPublisherPrefix)
            ? selectionPreview.allowedMagnitudes
            : undefined,
        selectionPreview: selectionPreview,
        isLoading: enabled && !selectionPreview && !isError,
    };
};
